import { render, staticRenderFns } from "./IncentivePage.vue?vue&type=template&id=9d2f9e10"
import script from "./IncentivePage.vue?vue&type=script&lang=js"
export * from "./IncentivePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports